'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RankedToggle = require('./components/RankedToggle.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RankedToggle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/ranked-toggle/index.js
// module id = 1052
// module chunks = 0